import React, { Component } from 'react'; 
import { Link } from 'react-router-dom';
class Mapa extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Mapa Interactivo</h2>
              </header>
              <span className="containerjuego">
          <div className="content">
            <div>
            <h2>
            <iframe src="https://es.educaplay.com/juego/16153666-dinoparque.html"width="1080" height="720" frameborder="1" allowfullscreen title="Mapa"></iframe>
            </h2>
            </div>
        
          </div>
            <div>
            <div className="containerjuego">
               <Link className="button" to="/juego">
                Regresar
              </Link>
            </div>
            </div>
            </span>
          </div>
          </div>
          );
    } 
} 

export default Mapa;